/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegenerateTermTreatmentPlanDto } from '../../models/regenerate-term-treatment-plan-dto';
import { RegenerationTextResultDto } from '../../models/regeneration-text-result-dto';

export interface DocumentAiV2ControllerRegenerateTermTreatmentPlan$Params {
      body: RegenerateTermTreatmentPlanDto
}

export function documentAiV2ControllerRegenerateTermTreatmentPlan(http: HttpClient, rootUrl: string, params: DocumentAiV2ControllerRegenerateTermTreatmentPlan$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerationTextResultDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiV2ControllerRegenerateTermTreatmentPlan.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegenerationTextResultDto>;
    })
  );
}

documentAiV2ControllerRegenerateTermTreatmentPlan.PATH = '/api/document-ai-v2/term-treatment-plan-ai/regenerate';
